import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfferComponent } from './offer/offer.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBottomSheetModule, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { SharedModule } from '../../shared/shared.module';
import { SuccessAnimatedLoadModule } from '../success-animated-load/success-animated-load.module';

@NgModule({
  declarations: [OfferComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatBottomSheetModule,
    SharedModule,
    SuccessAnimatedLoadModule
   ],
  exports: [
    OfferComponent
  ],
  providers: [
    {provide: MatBottomSheetRef, useValue: {}},
    {provide: MAT_BOTTOM_SHEET_DATA, useValue: {}}
  ]
})
export class OfferModule { }
